'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdAllOut = function MdAllOut(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.8 26.7c3.5-3.5 3.5-9.4 0-12.9s-9.4-3.5-12.9 0-3.5 9.4 0 12.9 9.4 3.5 12.9 0z m1.8-14.7c4.5 4.6 4.5 12 0 16.5s-12 4.5-16.5 0-4.5-11.9 0-16.5 12-4.5 16.5 0z m-21.6 1.6v-6.6h6.7z m6.7 20h-6.7v-6.6z m20-6.6v6.6h-6.7z m-6.7-20h6.7v6.6z' })
        )
    );
};

exports.default = MdAllOut;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/all-out.js
// module id = 2055
// module chunks = 0